import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/svg/sm-google.svg'
import _imports_1 from '../assets/svg/sm-facebook.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-1b84a90e")

_pushScopeId("data-v-1b84a90e")
const _hoisted_1 = { class: "register-content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, "Sign In", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("a", {
  class: "forgot",
  href: "/reset-password"
}, "Forgot your password?", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Sign in ")
const _hoisted_5 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "Connect With Google", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "Connect With Facebook", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "Don't have an account? ", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Sign Up")
const _hoisted_11 = /*#__PURE__*/_createVNode("h1", null, "Two Factor Authentication", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("p", null, "Please check your email for your code", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Remember this browser for 30 days")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Verify ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Re-send ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_grid, { class: "register-sign-in no-pad" }, {
        default: _withId(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center ion-justify-content-center" }, {
            default: _withId(() => [
              _createVNode(_component_ion_col, {
                sizeMd: "6",
                sizeSm: "12"
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_1, [
                    (!_ctx.showTwoFactor)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _hoisted_2,
                          _createVNode(_component_ion_input, {
                            modelValue: _ctx.email,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event)),
                            class: "sign-in-input",
                            type: "email",
                            placeholder: "Email"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ion_input, {
                            modelValue: _ctx.password,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event)),
                            class: "sign-in-input last-input",
                            type: "password",
                            placeholder: "Password"
                          }, null, 8, ["modelValue"]),
                          _hoisted_3,
                          _createVNode(_component_ion_button, {
                            color: "success",
                            onClick: _ctx.signIn
                          }, {
                            default: _withId(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_ion_button, {
                            class: "google social-button",
                            fill: "clear",
                            expand: "block",
                            size: "large",
                            onClick: _ctx.loginGoogle
                          }, {
                            default: _withId(() => [
                              _hoisted_5,
                              _hoisted_6
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_ion_button, {
                            class: "facebook social-button",
                            expand: "block",
                            size: "large",
                            onClick: _ctx.loginFacebook
                          }, {
                            default: _withId(() => [
                              _hoisted_7,
                              _hoisted_8
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _hoisted_9,
                          _createVNode(_component_router_link, { to: "/register" }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_button, { color: "secondary" }, {
                                default: _withId(() => [
                                  _hoisted_10
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.showTwoFactor)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _hoisted_11,
                          _hoisted_12,
                          _createVNode(_component_ion_input, {
                            modelValue: _ctx.twoFactorCode,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.twoFactorCode = $event)),
                            class: "sign-in-input",
                            type: "text",
                            placeholder: "Two Factor Code"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ion_row, {
                            class: "ion-no-padding ion-no-margin",
                            style: {"width":"100%"}
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_col, {
                                size: "1",
                                class: "ion-no-padding ion-no-margin"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_checkbox, {
                                    onIonChange: _ctx.updateRemember,
                                    checked: _ctx.rememberMe
                                  }, null, 8, ["onIonChange", "checked"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                size: "11",
                                class: "ion-no-padding ion-no-margin"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withId(() => [
                                      _hoisted_13
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { class: "ion-no-padding ion-no-margin" }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_col, { class: "ion-no-padding ion-no-margin" }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_button, {
                                    style: {"margin-left":"0"},
                                    color: "success",
                                    onClick: _ctx.verifyTwoFactor
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_14
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, { class: "ion-no-padding ion-no-margin" }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_button, {
                                    color: "danger",
                                    onClick: _ctx.signIn
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_15
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                class: "full-bg mobile-none",
                sizeMd: "6",
                sizeXs: "0"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})